window.global = window
window.process = window.process || {}
window.process.env = window.process.env || {}

Object.assign(window.process.env, import.meta.env)
